export default __webpack_public_path__ + "static/media/spring.9087881a.gif";